/**
 * Acordeoes do rodape.
 *
 * As colunas sao <details>. No computador tem de ficar sempre abertas; no
 * celular comecam fechadas, como na referencia. Nao da para resolver so com
 * CSS: quando o <details> esta fechado, o navegador esconde o conteudo por
 * regra interna, que nem sempre cede a um display no filho. Entao o atributo
 * `open` e quem manda, e este script o acerta conforme a largura da tela.
 *
 * O que o visitante abriu no celular e preservado enquanto ele nao atravessar
 * o breakpoint.
 */
const BREAKPOINT = 750;

function sincronizar() {
  const desktop = window.matchMedia(`(min-width: ${BREAKPOINT}px)`).matches;

  for (const coluna of document.querySelectorAll('.footer-mofo__column')) {
    if (desktop) {
      coluna.open = true;
      continue;
    }

    // Ao entrar no celular, fecha tudo uma vez - depois o visitante manda.
    if (coluna.dataset.mofoMobile !== 'true') {
      coluna.open = false;
      coluna.dataset.mofoMobile = 'true';
    }
  }

  if (desktop) {
    for (const coluna of document.querySelectorAll('.footer-mofo__column')) {
      delete coluna.dataset.mofoMobile;
    }
  }
}

sincronizar();
window.matchMedia(`(min-width: ${BREAKPOINT}px)`).addEventListener('change', sincronizar);
